<template>
  <div class="table_card">
    <div class="table_card__head">
      <v-layout row wrap>
        <v-flex lg9>
          <p class="table_card__head--title">Editar Información</p>
        </v-flex>
      </v-layout>
    </div>
    <div class="table_card__info">
      <v-layout row wrap>
      <v-flex xs6>
        <span class="table_card__info--label">Foto</span>
        <div class="trainers__form--photo_container">
          <label
            for="trainerPhoto"
            class="faccess_button buttom_shadow px-5">Examinar</label>
          <input
            id="trainerPhoto"
            type="file"
            accept="image/x-png,image/gif,image/jpeg"
            @change="onFileChange"
            name="logo">
          <p>{{photo_name=='manager'?'No se han seleccionado archivos':photo_name}}</p>
        </div>
        <v-flex xs12>
          <span class="table_card__info--label">Título</span>
          <input
            class="faccess_input"
            type="text"
            name="Title"
            placeholder="Título principal"
            v-model="company_info.attributes.title"
            @input="validate_form()"
          >
        </v-flex>
        <v-flex xs12>
          <span class="table_card__info--label">Texto</span>
          <textarea
            class="faccess_textarea"
            v-model="company_info.attributes.text"
            name="Text"
            placeholder="Texto principal"
            @input="validate_form()"
          ></textarea>
        </v-flex>
        <v-flex xs12>
          <span class="table_card__info--label">Misión</span>
          <textarea
            class="faccess_textarea"
            v-model="company_info.attributes.mission"
            name="Mission"
            placeholder="Misión de la compañia"
            @input="validate_form()"
          ></textarea>
        </v-flex>
        <v-flex xs12>
          <span class="table_card__info--label">Visión</span>
          <textarea
            class="faccess_textarea"
            v-model="company_info.attributes.vision"
            name="Vision"
            placeholder="Visión de la compañia"
            @input="validate_form()"
          ></textarea>
        </v-flex>
      </v-flex>
      <v-flex xs6 class="preview_item">
        <preview-about-us
          :company_info="company_info"
          :url="url"
        ></preview-about-us>
      </v-flex>
    </v-layout>

    </div>
    <div class="table_card__footer">
      <button
        class="faccess_button px-5"
        :class="validate_fields ? '' : 'disabled'"
        @click="saveCompanyInfo()"
      >
        Editar
      </button>
    </div>
  </div>
</template>

<script>
import PreviewAboutUs from './PreviewAboutUs.vue'
export default {
  components:{PreviewAboutUs},
  data(){
    return{
      company_info:{
        attributes:{
          image:'',
          title: '',
          text:'',
          mission:'',
          vision:'',
          sections_title:'',
          sections:[]
        }
      },
      validate_fields: false,
      photo_name: 'No se han seleccionado archivos',
      url_change: false,
      url:'',
    }
  },
  watch:{
    url(){
      this.url_change = true;
    }
  },
  mounted(){
    this.validate_form();
    this.find_company_info();
  },
  methods:{
    validate_form(){
      if(this.company_info.attributes.image != '' &&
         this.company_info.attributes.title != '' &&
         this.company_info.attributes.text != '' ){
        this.validate_fields = true
      }else{
        this.validate_fields = false
      }
      console.log("validate form ", this.validate_fields);
    },
    onFileChange (e) {
      var files = e.target.files || e.dataTransfer.files
      if (!files.length) {
        return
      }
      var name_field = ""+e.target.name
      this.url = URL.createObjectURL(files[0]);
      this.createImage(files[0], ""+e.target.name)
    },
    createImage (file, name_field) {
      var reader = new FileReader()
      var vm = this
      reader.readAsDataURL(file);
      reader.onload = function () {
        vm.company_info.attributes.image = reader.result
        vm.photo_name=name_field
        // vm.location.attributes.image = reader.result
      }
    },
    find_company_info(){
      try {
        this.$http.get('app/company/find_company_info/' + this.getCompany().id,
          {headers:
            {"X-Device-ID" : this.getDeviceId(),
             "Authorization" : 'Bearer ' + this.getUserToken()}})
        .then(function(response){
          console.log(response)
          this.company_info = response.body.data
          this.url = this.company_info.attributes.image.url
          this.validate_form()
          if(response.body.meta != undefined && response.body.meta != null){
            if(response.body.meta.authentication_token != undefined && response.body.meta.authentication_token != null){
              this.checkToken(response.body.meta.authentication_token)
            }
          }
        }, function(response){
          console.log(response)
          if(response.body.meta != undefined && response.body.meta != null){
            if(response.body.meta.authentication_token != undefined && response.body.meta.authentication_token != null){
              this.checkToken(response.body.meta.authentication_token)
            }
          }
          if(typeof response.body.errors[0].details != "object"){
            alert(response.body.errors[0].details);
          }else{
            let message = []
            for(var key in response.body.errors[0].details){
              message.push(response.body.errors[0].details[key])
            }
            alert(message);
          }
        })
      } catch (e) {
        alert(e.message)
      }
    },
    saveCompanyInfo(){

      try {
        this.$http.post('app/company/save_company_info',
          {data: this.encrypt(this.company_info).toString()},
          {headers:
            {"X-Device-ID" : this.getDeviceId(),
             "Authorization" : 'Bearer ' + this.getUserToken()}})
        .then(function(response){
          console.log(response)
          if(response.body.meta != undefined && response.body.meta != null){
            if(response.body.meta.authentication_token != undefined && response.body.meta.authentication_token != null){
              this.checkToken(response.body.meta.authentication_token)
            }
          }
          alert("Información de la compañia editada con exito")
        }, function(response){
          console.log(response)
          if(response.body.meta != undefined && response.body.meta != null){
            if(response.body.meta.authentication_token != undefined && response.body.meta.authentication_token != null){
              this.checkToken(response.body.meta.authentication_token)
            }
          }
          if(typeof response.body.errors[0].details != "object"){
            alert(response.body.errors[0].details);
          }else{
            let message = []
            for(var key in response.body.errors[0].details){
              message.push(response.body.errors[0].details[key])
            }
            alert(message);
          }
        })
      } catch (e) {
        alert(e.message)
      }
    },
  }
}
</script>

<style lang="css">
  .text_title{
    font-weight: bold;
    font-size: 16px;
  }
</style>



// WEBPACK FOOTER //
// src/components/views/client_information/AboutUs.vue